import { v1 } from 'uuid';

import { fetchMethods } from '../static/constants';
import { FetchError } from '../models';
import { getEnv, isDev, isDocker } from './env';
import { IUser, IAuthHeaders } from '../models';

import mockFetch from '../mocks/mockFetcher';

const apiRoot = isDocker() ? 'http://localhost:8035' : `https://connect.${getEnv()}`;

export const doFetch = async (path: string, headers: {} = {}, method: string = fetchMethods.GET, body: any = null) => {
    if (isDev()) {
        if (body) {
            console.info("Request body:", body)
        }
        return await mockFetch(path, method);
    }

    const options: { headers: {}; method: string; body?: any } = {
        headers,
        method,
    };

    if (body) {
        options.body = JSON.stringify(body);
        options.headers = {
            ...options.headers,
            'Content-Type': 'application/json',
        };
    }

    try {
        const response = await window.XERO.secureFetch.request(`${apiRoot}/${path}`, options, { waitForAccessToken: true })
        if (response.ok) {
            return response.status === 200 ? response.json() : response.text();
        }

        if (response.status === 403 || response.status === 400) {
            throw new FetchError(response.statusText, response.status, response.json());
        }

        throw new FetchError(response.statusText, response.status);
    } catch (error) {
        throw error;
    }
};

export const generateHeaders = (user: IUser): IAuthHeaders => {
    let headers: IAuthHeaders = {
        'Xero-Correlation-Id': v1(),
    };

    if (user.tenantId) {
        headers = {
            ...headers,
            'Xero-Tenant-Id': user.tenantId,
        };
    }

    return headers;
};
